





















import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
  name: 'catalog-product-list-attribute-filter'
})

export default class extends Vue {
  @Prop() readonly dataSource: string;
  @Prop() readonly filter!: object;

  private splitColumns: boolean = false;
  private filtersToShow: number = 0;
  private filterCollapsed: boolean = false;
  private filterOpen: boolean = !!!this.$mobileDetect.mobile();

  private created(): void {
    this.splitColumns = (this.filter['layout'] || '') === '2columns';
    this.filtersToShow = this.splitColumns ? 10 : 5;
    this.filterCollapsed = this.filter['options'].length > this.filtersToShow;
  }

  private get sortedFilters() {
    return [...this.filter['options']].sort((a, b) => b.result_count - a.result_count);
  }

  private toggleFilterValueCollapse(): void {
    this.filterCollapsed = !this.filterCollapsed;
  }

  private filterIsVisibleCheck(index): boolean {
    return this.filterCollapsed ? index < this.filtersToShow : true;
  }

  private toggleFilter(): void {
    this.filterOpen = !this.filterOpen;
  }
}
